export default __webpack_public_path__ + "static/media/Photo03.377ed459.jpg";